export enum InsumoProveedorEstado {
  Borrador,
  Actualizado,
  Desactualizado,
}

export const InsumoProveedorEstadoLabels: {
  [key in InsumoProveedorEstado]: string;
} = {
  [InsumoProveedorEstado.Borrador]: 'Borrador',
  [InsumoProveedorEstado.Actualizado]: 'Actualizado',
  [InsumoProveedorEstado.Desactualizado]: 'Desactualizado',
};

export const getInsumoProveedorEstado = () => {
  return Object.values(InsumoProveedorEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: InsumoProveedorEstadoLabels[id as InsumoProveedorEstado],
    }));
};

export const colorMapping: { [key in InsumoProveedorEstado]: string } = {
  [InsumoProveedorEstado.Borrador]: '#70BDFF',
  [InsumoProveedorEstado.Actualizado]: 'green',
  [InsumoProveedorEstado.Desactualizado]: 'orange',
};
